<template>
  <div class="flow-reference-modal">
    <div class="modal">
      <div class="content">
        <div class="pull-right">
          <div class="btn-close" @click="close"></div>
        </div>
        <div class="tab">
          <h2>Einstellungen</h2>
          <form @submit.prevent="save()">
            <div class="custom-wrapper">
              <!-- Branding disabled -->
              <label v-show="false">Branding</label>
              <input
                v-show="false"
                type="color"
                v-model="flowSettings.brandingColor"
                required
              />

              <label>Knopftext</label>
              <input type="text" v-model="flowSettings.btnCaption" required />
              <div class="btn">{{ flowSettings.btnCaption }}</div>
              <label>Nachricht während dem Ladevorgang</label>
              <input type="text" v-model="flowSettings.loadingCaption" />
              <div>
                <label>API-Endpoint</label>
                <input
                  type="text"
                  v-model="flowSettings.apiEndpoint"
                  :disabled="!isUserHasAccess"
                  required
                />
              </div>
              <LoadingSpinner
                :loadingCaption="flowSettings.loadingCaption"
                v-show="isLoading"
              />
              <div class="switch-group row d-flex flex align-items-center">
                <div class="col-9 pt-0">
                  <label class="caption p-0">Full Width</label>
                </div>
                <div class="col-3">
                  <label name="required" class="switch class pull-right">
                    <input type="checkbox" v-model="flowSettings.fullWidth" />
                    <span class="slider round"></span>
                  </label>
                </div>
                <div class="col-9 pt-3">
                  <label class="caption p-0"
                    >Ergebnisse nebem dem Form anzeigen</label
                  >
                </div>
                <div class="col-3 pt-3">
                  <label name="required" class="switch class pull-right">
                    <input
                      type="checkbox"
                      v-model="flowSettings.showResultInForm"
                      @change="onChangeShowResultInForm()"
                    />
                    <span class="slider round"></span>
                  </label>
                </div>
              </div>
            </div>
            <hr v-if="process.type == 'action'" />
            <div class="database-select" v-if="process.type == 'action'">
              <h3>Datenbank auswählen</h3>
              <p>Wählen Sie, auf welche Datenbank ihr Flow zugreifen soll.</p>

              <div class="selected-database-container">
                <div
                  class="database-list-item"
                  v-for="(db, index) in getSelectedDbList()"
                  :key="`db.caption${index}`"
                >
                  <span>{{ db.caption }}</span>
                  <i
                    class="far fa-trash-alt"
                    @click="removeSelectedDb(db.name)"
                  ></i>
                </div>
              </div>

              <GeneralDropdown className="database-dropdown">
                <template v-slot:selectFilter>
                  <span class="database-dropdown-placeholder">
                    Datenbank hinzufügen...</span
                  >
                </template>
                <template v-slot:optionData>
                  <b-dropdown-item
                    v-for="database in filteredDatabaseList"
                    :key="database.name"
                    @click="addSelectedDatabase(database)"
                  >
                    {{ database.caption }}
                  </b-dropdown-item>
                </template>
              </GeneralDropdown>
              <!-- <select
                v-model="process.tableID"
                @click="isSelectTableActive = true"
                @mouseleave="isSelectTableActive = false"
                :class="{
                  highlighted: showHighlightedSelect,
                }"
              >
                <option v-for="d in databases" :key="d.name" :value="d.name">
                  {{ d.caption }}
                </option>
              </select> -->
            </div>
            <hr />
            <div class="security-wrapper">
              <h2>Sicherheit</h2>
              <p class="explenation">
                Webseiten, von denen aus Ihr Flow aufgerufen werden darf. Wenn
                keine Webseiten definiert sind, kann der Flow von überall
                ausgeführt werden.
              </p>
              <div class="url-list">
                <div
                  v-for="(d, indx) in domains"
                  :key="indx"
                  class="url-list-item"
                >
                  <input
                    type="text"
                    placeholder="Domainename"
                    v-model="d.value"
                    :disabled="!isUserHasAccess"
                  />
                  <div class="tools">
                    <i
                      class="far fa-trash-alt"
                      @click="removeElement(indx)"
                      :disabled="!isUserHasAccess"
                    ></i>
                  </div>
                </div>
                <input
                  class="new-item"
                  ref="newOption"
                  type="text"
                  placeholder="Neuen Domainname Hinzufügen ..."
                  :disabled="!isUserHasAccess"
                  @change="addOption()"
                />
              </div>
              <!--
              <label>Speicher option</label>
              <p class="explenation">
                Um Ihre aufrufe nach zu verfolgen, können Sie einen Parameter aus
                Ihrer eigenen Umgebung an die Anfrage hängen. Bestimmen Sie, wo
                der Prozess danach sucht.
              </p>
              <select v-model="flowSettings.reference.storageOption">
                <option v-for="o in storageOptions" :key="o">
                  {{ o }}
                </option>
              </select>
              <label>Label:</label>
              <p class="explenation">
                Wenn Sie einen Parameter zur verfolgung benützen wollen, geben Sie
                bitte den Namen des Parameters an.
              </p>
              <input v-model="flowSettings.reference.label" />
              <label>Typ</label>
              <p class="explenation">Wählen Sie den Typ für ihr label aus.</p>
              <select v-model="flowSettings.reference.type">
                <option v-for="t in typeList" :key="t.name" :value="t.name">
                  {{ t.caption }}
                </option>
              </select>
              <label>Testwert:</label>
              <p class="explenation">
                Geben Sie einen Wert an um in der Codelos Plattform zu testen.
              </p>
              <input v-model="flowSettings.reference.value" />
            -->

              <div class="switch-group row">
                <div class="col-9 pt-3">
                  <label class="caption">Codelos Authentifizierung</label>
                </div>
                <div class="col-3">
                  <label name="required" class="switch class pull-right">
                    <input
                      type="checkbox"
                      :checked="hasTokenInput"
                      :disabled="isPublicFlow || !isUserHasAccess"
                      @click="handleAuth()"
                    />
                    <span
                      class="slider round"
                      :disabled="!isUserHasAccess"
                    ></span>
                  </label>
                </div>
              </div>
              <div class="switch-group row">
                <div class="col-9 pt-3">
                  <label class="caption"
                    >Öffentlichen Lesezugriff gewähren</label
                  >
                </div>
                <div class="col-3">
                  <label name="required" class="switch class pull-right">
                    <input
                      type="checkbox"
                      :checked="isPublicFlow"
                      :disabled="!isUserHasAccess"
                      @click="handlePublicFlow()"
                    />
                    <span
                      class="slider round"
                      :disabled="!isUserHasAccess"
                    ></span>
                  </label>
                </div>
              </div>
              <div class="row" v-if="this.isPublicFlow">
                <div class="col-12">
                  <p>
                    Jeder, der über den Link verfügt, kann diesen Prozess
                    ausführen.
                  </p>
                </div>
              </div>
            </div>
          </form>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import LoadingSpinner from '../widgets/LoadingSpinner.vue';
import GeneralDropdown from '../core/general-dropdown.vue';

export default {
  name: 'flowReferenceModal',
  data() {
    return {
      isLoading: false,
      domains: [],
      isPublicFlow: true,
      publicFlowPolicy: null,
      fullWidth: false,
      isSelectTableActive: false,
      databases: [],
      storageOptions: ['cookie', 'localStorage', 'sessionStorage'],
      typeList: [
        {
          name: 'text',
          caption: 'Text',
          icon: '',
        },
        {
          name: 'number',
          caption: 'Zahl',
          icon: '',
        },
      ],
      filteredDatabaseList: [],
    };
  },
  props: {
    flowSettings: {
      fullWidth: {
        type: Boolean,
        default: false,
      },
      btnCaption: {
        type: String,
        default: 'Bestätigen',
      },
      loadingCaption: {
        type: String,
        default: 'Wird geladen',
      },
      reference: {
        storageOption: String,
        label: String,
        type: String,
        value: String,
      },
      showResultInForm: {
        type: Boolean,
        default: false,
      },
      domains: [],
    },
    isUserHasAccess: { type: Boolean, default: true },
    task: Object,
    process: Object,
    isAdmin: Boolean,
    showDatabaseMissing: Boolean,
    isTableIdArray: Boolean,
  },
  methods: {
    addSelectedDatabase(database) {
      if (!database && !database.name) return;
      if (!this.isTableIdArray) {
        this.process.tableID = [this.process.tableID, database.name];
      }

      if (this.isTableIdArray) {
        this.process.tableID.push(database.name);
      }

      this.filterDatabases();
    },
    filterDatabases() {
      let selectedDbArr = [];
      if (!this.isTableIdArray) {
        selectedDbArr.push(this.process.tableID);
      }

      if (this.isTableIdArray) {
        selectedDbArr = this.process.tableID;
      }

      this.filteredDatabaseList = this.databases.filter(
        (el) => !selectedDbArr.includes(el.name.trim())
      );
    },
    getSelectedDbList() {
      let selectedDbArr = [];
      if (!this.isTableIdArray) {
        selectedDbArr.push(this.process.tableID);
      }

      if (this.isTableIdArray) {
        selectedDbArr = this.process.tableID;
      }

      const dbList = this.databases.filter((el) =>
        selectedDbArr.includes(el.name.trim())
      );

      return dbList;
    },
    removeSelectedDb(databaseID) {
      if (!this.isTableIdArray) {
        this.process.tableID = [];
      }

      if (this.isTableIdArray) {
        const tempArr = this.process.tableID.filter(
          (el) => el.trim() !== databaseID.trim()
        );
        this.process.tableID = tempArr;
      }

      this.filterDatabases();
    },

    close() {
      this.$emit('close');
    },
    save() {
      this.$emit('save');
    },
    addOption() {
      var newOption = this.$refs.newOption.value.trim();
      if (newOption != '') {
        this.domains.push({ value: newOption });
        this.$refs.newOption.value = '';
      }
    },
    removeElement(i) {
      if (!this.isUserHasAccess) return;
      this.domains.splice(i, 1);
    },
    handleAuth() {
      if (!this.hasTokenInput) {
        let e = {
          label: 'Authentication',
          name: 'authentication',
          type: 'html',
          value:
            // ATTENTION: / (slash) in <\/script> end tags must be delimited using \ after each format of the document
            // eslint-disable-next-line no-useless-escape
            '<html>\n<input type="hidden" name="authorization" value="">\n</html>\n<script>\n//Get Token\nvar userName = localStorage.getItem("CognitoIdentityServiceProvider.61nps3sbkg5vcrn4vl5hduqbf4.LastAuthUser")\nvar token = localStorage.getItem("CognitoIdentityServiceProvider.61nps3sbkg5vcrn4vl5hduqbf4." + userName + ".accessToken")\ndocument.getElementsByName("authorization")[0].value =  "Bearer " + token\n<\/script>\n',
          options: [],
          attributes: {
            required: false,
          },
        };
        this.task.props.formTrigger.elements.push(e);
      } else {
        // Remove Auth input from start if user disabled authentication
        let indx = this.task.props.formTrigger.elements.findIndex(
          (e) => e.label == 'Authentication' && e.type == 'html'
        );
        this.task.props.formTrigger.elements.splice(indx, 1);
      }
    },

    handlePublicFlow() {
      this.isPublicFlow = !this.isPublicFlow;

      if (this.isPublicFlow) {
        this.addPublicAccess();

        // Remove authentication
        if (this.hasTokenInput) this.handleAuth();
      } else {
        this.removePublicAccess();
      }
    },

    checkPublicFlow() {
      this.isLoading = true;
      var url = process.env.VUE_APP_DATA_API;
      url += '/flow/' + this.process.id;
      url += '/public-access';

      return fetch(url, { method: 'GET' })
        .then((data) => data.json())
        .then((json) => {
          this.isPublicFlow = json['is_public'];
          this.publicFlowPolicy = json['id'];
          this.isLoading = false;
        });
    },

    addPublicAccess() {
      var url = process.env.VUE_APP_DATA_API;
      url += '/flow/share';

      let myHeaders = new Headers();
      myHeaders.append(
        'Authorization',
        'Bearer ' + this.user.signInUserSession.accessToken.jwtToken
      );
      myHeaders.append('Content-Type', 'application/json');

      let payload = {
        recipient: 'public',
        flow_id: this.process.id,
        access_level: 'execute',
      };

      fetch(url, {
        body: JSON.stringify(payload),
        headers: myHeaders,
        method: 'PUT',
      })
        .then(async (response) => {
          if (response.status == 200) return response.json;
          else if (response.status == 404) throw new Error('Email not found');
          else if (response.status == 401)
            throw new Error('Access Token has expired');
          else if (response.status == 400) {
            let jsn = await response.json().then((jsn) => {
              return jsn['message'];
            });
            throw new Error(jsn);
          } else throw new Error('CORS');
        })
        .then(() => {})
        .catch((e) => {
          if (e == 'Error: Access Token has expired') {
            localStorage.clear(),
              this.$router.push({
                name: 'auth',
                params: { message: 'Sitzung abgelaufen' },
              });
          } else if (e == 'Error: Email not found') {
            this.showError(
              'Die angegebene E-Mail-Adresse wurde nicht gefunden.'
            );
          } else if (e == 'Error: User is owner') {
            this.showError('Der User hat bereits Zugriff auf den Flow.');
          }
        });
    },

    removePublicAccess() {
      var url = process.env.VUE_APP_DATA_API;
      url += '/flow/share';

      let myHeaders = new Headers();
      myHeaders.append(
        'Authorization',
        'Bearer ' + this.user.signInUserSession.accessToken.jwtToken
      );
      myHeaders.append('Content-Type', 'application/json');

      let payload = {
        policy_id: this.publicFlowPolicy,
        flow_id: this.process.id,
      };

      fetch(url, {
        headers: myHeaders,
        body: JSON.stringify(payload),
        method: 'DELETE',
      })
        .then((response) => {
          if (response.status == 200) return response.json();
          else if (response.status == 404) throw new Error('Email not found');
          else if (response.status == 401)
            throw new Error('Access Token has expired');
          else throw new Error('CORS');
        })
        .then(() => {})
        .catch((e) => {
          if (e == 'Error: Access Token has expired') {
            localStorage.clear();
            this.$router.push({
              name: 'auth',
              params: { message: 'Sitzung abgelaufen' },
            });
          }
        });
    },
    getCustomDatabases() {
      var url = process.env.VUE_APP_DATA_API;
      url += '/user-tables';

      // API headers
      var myHeaders = new Headers();
      myHeaders.append(
        'Authorization',
        'Bearer ' + this.user.signInUserSession.accessToken.jwtToken
      );

      return fetch(url, {
        headers: myHeaders,
        method: 'GET',
      })
        .then((response) => {
          return response.json();
        })
        .then((json) => {
          let dbs;
          let dType = this.process.dataType;
          if (dType == 'timeseries' || dType == 'loadprofile') {
            dbs = json.filter(
              (e) => e.type == this.process.dataType || e.type == 'loadprofile'
            );
          } else dbs = json.filter((e) => e.type == this.process.dataType);

          this.databases = dbs;
          this.filterDatabases();
        })
        .catch(() => {});
    },
    onChangeShowResultInForm() {
      this.$emit('setShowResultInForm', this.flowSettings.showResultInForm);
    },
  },
  created() {
    // Handle Domains
    this.flowSettings.domains.forEach((e) => {
      this.domains.push({ value: e });
    });

    // Handle public flow
    this.checkPublicFlow();

    // Get all tables
    this.getCustomDatabases();
  },
  watch: {
    acceptedDomains() {
      this.flowSettings.domains = [];
      this.acceptedDomains.forEach((e) => this.flowSettings.domains.push(e));
    },
  },
  computed: {
    acceptedDomains() {
      return this.domains.map((e) => e.value);
    },
    hasTokenInput() {
      return (
        this.task.props.formTrigger.elements.filter(
          (e) => e.type == 'html' && e.label == 'Authentication'
        ).length > 0
      );
    },
    user() {
      return this.$store.state.user;
    },
    showHighlightedSelect() {
      let a = this.showDatabaseMissing;
      let b = !this.isSelectTableActive;
      let c = this.process.tableID == '';
      return a && b && c;
    },
  },
  components: {
    LoadingSpinner,
    GeneralDropdown,
  },
};
</script>

<style scoped>
@import 'https://use.fontawesome.com/releases/v5.6.3/css/all.css';
.modal-backdrop {
  position: fixed;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  background-color: rgba(0, 0, 0, 0.3);
  display: flex;
  justify-content: center;
  align-items: center;
}

.modal {
  background: #ffffff;
  border-radius: 4px;
  display: block;
  width: 65%;
  text-align: left;
  font-family: 'Open Sans', open-sans, sans-serif;
  -webkit-font-smoothing: antialiased;
  font-size: 12px;
  line-height: 17px;
  color: #5f697a;
  top: 1.1%;
  height: 98%;
  right: 5%;
  float: right;
  left: auto;
  width: 425px;
  border-left: 1px solid #dee3e9;
  border-left-width: 1px;
  border-left-style: solid;
  border-left-color: rgb(222, 227, 233);
  flex: 1;
  float: right;
  position: fixed;
  border-radius: 0px 10px 10px 0px;
}

.heading {
  padding: 15px 15px 0px;
  text-align: center;
}

.content {
  background-color: #fff;
  width: 100%;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
  text-align: center;
}

[disabled] {
  opacity: 0.5;
  cursor: not-allowed !important;
}

h1 {
  padding-top: 50px;
  padding-bottom: 8px;
  text-align: center;
  font-size: 33px;
  color: #464d5d;
  margin: 0 0 12px;
  font-weight: 400;
  line-height: 35px;
  text-rendering: optimizelegibility;
  -webkit-font-smoothing: antialiased;
}

h3 {
  color: #70787e;
  font-size: 18px;
  text-transform: uppercase;
  letter-spacing: 0.03em;
  margin-bottom: 10px;
}

h4 {
  color: rgba(85, 93, 109, 0.4);
  font-size: 11px;
  text-transform: uppercase;
  letter-spacing: 0.03em;
  margin-bottom: 0px;
}

.tab {
  text-align: left;
  border-top: 1px solid #eaecf1;
  background: #fff;
  padding: 38px 40px 2px 40px;
  min-height: 190px;
}

select {
  width: 70%;
}

select.highlighted {
  background: #ff000024;
}

.date {
  width: 53%;
}

.time {
  width: 33%;
}

textarea {
  resize: none;
  float: left;
  background: #fff;
  border-top-right-radius: 0;
  border-bottom-right-radius: 0;
  border-right: medium none;
  padding-left: 12px;
  padding-bottom: 15px;
  margin-bottom: 0;
  padding-bottom: 14px;
  padding-top: 15px;
  color: #464d5d;
  border: 1px solid #dee3e9;
  border-radius: 2px;
  font-size: 14px;
  font-weight: 400;
  line-height: 19px;
  margin: 0 0 20px;
  -webkit-font-smoothing: antialiased;
  -webkit-box-shadow: none;
  box-shadow: none;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
  height: 200px;
  width: 100%;
  overflow: hidden;
}

button {
  border: 1px solid #dee3e9;
  border-radius: 3px 3px 3px 3px;
  width: 30%;
  height: 51px;
  text-transform: uppercase;
  font-weight: 600;
  margin-top: 25px;
}

button.default {
  color: #464d5d;
  background: #fff;
}

.input-group {
  display: inline-block;
  width: 100%;
}

.imput-group > input {
  width: 40%;
  margin: 0px 20px 20px 0px;
}

.pull-right {
  float: right;
  margin-right: 15px;
  margin-top: 15px;
}

.col-3 .pull-right {
  margin-right: 0px;
  margin-top: 5px;
}

.btn-green {
  color: white;
  background: #4aae9b;
  border: 1px solid #4aae9b;
  border-radius: 2px;
}

ul.tabsLabels {
  display: inline-block;
  padding: 0;
  margin: 0 0 -1px;
}

.modal ul.tabsLabels li {
  display: inline-block;
  margin-right: 44px;
  list-style: none;
  padding: 0;
  line-height: 14px;
}

.modal:not(.custom) li {
  font-size: 14px;
  line-height: 25px;
  color: #7e8890;
}

.modal ul.tabsLabels a {
  color: #a4abb1;
  font-size: 12px;
  font-weight: 400;
  text-transform: uppercase;
  padding: 21px 7px 22px 33px;
  border-bottom: 2px solid transparent;
  display: block;
  position: relative;
}

.modal ul.tabsLabels a.datetime {
  padding: 21px 7px 22px 0px;
}

a {
  text-decoration: none;
  -webkit-transition: color 0.2s ease, background-color 0.2s ease,
    border-color 0.2s ease;
  -o-transition: color 0.2s ease, background-color 0.2s ease,
    border-color 0.2s ease;
  transition: color 0.2s ease, background-color 0.2s ease,
    border-color 0.2s ease;
  cursor: pointer;
}

a {
  background-color: transparent;
}

.modal ul.tabsLabels a.active {
  border-color: #52b266;
}

.modal ul.tabsLabels a.active,
.modal ul.tabsLabels a:hover {
  color: #464d5d;
  text-decoration: none;
}

/*@media not all, not all, (-webkit-min-device-pixel-ratio: 1.5), not all, (min-resolution: 1.5dppx)*/

.tabsLabels .email {
  background-image: url('../../assets/img/modal-sprite.png');
  background-size: 1293px 1277px;
  background-position: -1100px -1110px;
}

.tabsLabels .alert {
  background-image: url('../../assets/img/modal-sprite.png');
  background-size: 1293px 1277px;
  background-position: -546px -1110px;
}

p {
  font-weight: 500;
  font-size: 15px;
  line-height: 21px;
  color: #70787e;
  margin: 25px 0px 25px 0px;
}

.tab .explenation {
  font-size: 13px;
  margin: 0;
}

.systems {
  background-color: #f9f9fb;
  font-family: 'Open Sans', open-sans, sans-serif;
  -webkit-font-smoothing: antialiased;
  font-size: 12px;
  color: #5f697a;
  line-height: 17px;
  margin: 0;
  display: block;
  overflow: auto;
  width: 100%;
}

.item-wrapper {
  display: block;
  position: relative;
  float: left;
  width: 120px;
  border-radius: 4px;
  background: #fff;
  height: 150px;
  text-align: center;
  margin: 0 39px 43px 0;
  -webkit-box-shadow: 0 1px 2px rgba(43, 59, 93, 0.29);
  box-shadow: 0 1px 2px rgba(43, 59, 93, 0.29);
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
}

.item-wrapper h2 {
  color: #424956;
  font-size: 12px;
  font-weight: 400;
  line-height: inherit;
  margin-top: 0px;
}

.systems-wrapper {
  width: 100%;
  margin: 24px 31px;
}

.img-wrapper {
  width: 100%;
  height: 111px;
}

.systems .logo {
  position: absolute;
  width: 70%;
  position: relative;
  top: 50%;
  transform: translateY(-50%);
}

.input-group > button {
  min-width: 0;
  width: 99px;
  height: 51px;
  text-transform: uppercase;
  font-weight: 600;
  background: #fff;
  margin-bottom: 0;
  margin-left: 0;
  border-radius: 0 3px 3px 0;
  margin-top: 0;
  font-size: 35px;
  font-weight: 200;
}

.input-group > select {
  margin-right: 0;
  border-radius: 0 3px 3px 0;
}

button {
  color: white;
  background: #4aae9b;
  border: 1px solid #4aae9b;
  border-radius: 2px;
  width: 30%;
  height: 51px;
  text-transform: uppercase;
  font-weight: 600;
  margin-top: 0;
  margin-bottom: 20px;
  margin-right: 30px;
}

label {
  display: block;
  padding-top: 0;
  padding-bottom: 9px;
  margin-right: 10px;
  margin-bottom: 0px;
  font-size: 13px;
  -webkit-font-smoothing: antialiased;
  box-shadow: none;
  box-sizing: border-box;
  width: 100%;
}

input,
select {
  border-radius: 0;
  background: #fff;
  border-top-right-radius: 0;
  border-bottom-right-radius: 0;
  border-right: medium none;
  width: 100%;
  margin-bottom: 0;
  height: 37px;
  color: #464d5d;
  border: 1px solid #dee3e9;
  border-radius: 2px;
  font-size: 14px;
  font-weight: 400;
  line-height: 19px;
  margin: 0 0 20px;
  -webkit-font-smoothing: antialiased;
  -webkit-box-shadow: none;
  box-shadow: none;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
  padding: 0px 15px 0px 15px;
}

.modal .database-dropdown {
  border-radius: 0;
  background: #fff;
  border-top-right-radius: 0;
  border-bottom-right-radius: 0;
  border-right: medium none;
  width: 100%;
  margin-bottom: 0;
  height: 37px;
  color: #464d5d;
  border: 1px solid #dee3e9;
  border-radius: 2px;
  font-size: 14px;
  font-weight: 400;
  line-height: 19px;
  margin: 0 0 20px;
  -webkit-font-smoothing: antialiased;
  -webkit-box-shadow: none;
  box-shadow: none;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
  padding: 0;
}

.flow-reference-modal .modal .database-dropdown .database-dropdown-placeholder {
  color: #464d5d;
}

.flow-reference-modal .modal .database-dropdown ::v-deep button {
  justify-content: space-between;
}

.flow-reference-modal
  .modal
  .database-dropdown
  ::v-deep
  button
  .dropdown-toggle-icon {
  padding: 0;
}

.modal .database-select .selected-database-container {
  border: 1px solid #dee3e9;
  margin: 0 0 20px;
  height: 130px;
  overflow-y: auto;
}
.modal .database-select .selected-database-container .database-list-item {
  display: flex;
  justify-content: space-between;
  padding: 7px 8px 7px 8px;
  align-items: center;
}

.modal .database-select .selected-database-container .database-list-item i {
  cursor: pointer;
}

.switch {
  position: relative;
  display: inline-block;
  width: 60px;
  height: 34px;
}

.switch input {
  opacity: 0;
  width: 0;
  height: 0;
}

.slider {
  position: absolute;
  cursor: pointer;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: #ccc;
  -webkit-transition: 0.4s;
  transition: 0.4s;
}

.slider:before {
  position: absolute;
  content: '';
  height: 26px;
  width: 26px;
  left: 4px;
  bottom: 4px;
  background-color: white;
  -webkit-transition: 0.4s;
  transition: 0.4s;
}

input:checked + .slider {
  background-color: #000;
}

input:checked + .slider:before {
  -webkit-transform: translateX(26px);
  -ms-transform: translateX(26px);
  transform: translateX(26px);
}

/*Switch*/
.switch {
  position: relative;
  display: inline-block;
  width: 60px;
  height: 34px;
}

.switch input {
  opacity: 0;
  width: 0;
  height: 0;
}

.slider {
  position: absolute;
  cursor: pointer;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: #ccc;
  -webkit-transition: 0.4s;
  transition: 0.4s;
}

.slider:before {
  position: absolute;
  content: '';
  height: 26px;
  width: 26px;
  left: 4px;
  bottom: 4px;
  background-color: white;
  -webkit-transition: 0.4s;
  transition: 0.4s;
}

input:checked + .slider {
  background-color: #000;
}

input:checked + .slider:before {
  -webkit-transform: translateX(26px);
  -ms-transform: translateX(26px);
  transform: translateX(26px);
}

/* Rounded sliders */
.slider.round {
  border-radius: 34px;
}

.slider.round:before {
  border-radius: 50%;
}

.option-list {
  clear: both;
  float: left;
  position: relative;
  width: 100%;
}

.option-list > ul {
  padding: 0;
  margin: 0;
  font-family: 'Open Sans', open-sans, sans-serif;
  -webkit-font-smoothing: antialiased;
  list-style: none;
}

.option-list ul li {
  float: left;
  clear: both;
  width: 100%;
  border-bottom: 1px solid #d8dee6;
  padding: 15px 0;
  font-size: 14px;
  color: #7e8890;
  line-height: 35px;
}

.option-list ul li.active {
  color: #323a45;
}

.switch-group {
  /* height: 65px; */
  /* width: 105%; */
}

.switch-group > label.caption {
  float: left;
  height: 53px;
  padding-top: 19px;
}

.url-list-item {
  width: 100%;
  padding-bottom: 5px;
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.modal.task .url-list-item .tools {
  padding: 0;
  height: 16px;
  justify-content: flex-end;
  flex-direction: unset;
}

.url-list-item .tools .i {
  font-size: 15px;
}

.url-list-item input {
  border: 0;
  background: transparent;
}

.url-list-item input[type='text'] {
  width: 68%;
  margin-left: 9px;
  display: inline;
  margin-top: 0px;
  margin-bottom: 0px;
  padding-top: 0px;
  height: 43px;
  font-size: 15px;
}

.url-list-item input[type='radio'] {
  width: 21px;
  float: left;
  margin-bottom: 0;
  height: 19px;
}

.new-item {
  border: 0;
  background: transparent;
  font-size: 15px;
}

.new-item::placeholder {
  text-decoration: underline;
}

.new-item:focus::placeholder {
  color: transparent;
}

.new-item:focus {
  background: #fff;
}

.url-list-item .tools {
  display: inline-block;
  height: 48px;
  padding: 0;
  cursor: pointer;
}

.btn {
  text-decoration: none;
  color: #fff;
  border: 3px solid #000;
  border-radius: 0.375em;
  cursor: unset;
  display: inline-block;
  font-family: proxima-nova, Helvetica Neue, Arial, sans-serif;
  font-weight: 700;
  line-height: 23px;
  padding: 0.5rem 1.5rem;
  white-space: pre;
  font-size: 0.9375rem;
  opacity: 1;
  transition: transform 0.2s linear 0s, background-color 0.2s linear 0s;
  transform: translateY(0) scale(1.001);
  background-color: #000;
  margin-bottom: 25px;
}

.loading {
  text-align: center;
  margin-bottom: 15px;
}

.progress-icon {
  position: unset;
  left: 0;
  margin-top: 15px;
  margin-left: auto;
  margin-right: auto;
}

.progress-icon:after {
  content: ' ';
  display: block;
  width: 50px;
  height: 50px;
  margin: 1px;
  border-radius: 50%;
  border: 2px solid #313745;
  border-color: #313745 transparent #313745 transparent;
  animation: progress-icon 1.2s linear infinite;
}

@keyframes progress-icon {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}

.custom-wrapper input[type='color'] {
  border: none;
  width: 110%;
  margin-left: -17px;
  height: 48px;
}
</style>
